import { render, staticRenderFns } from "./ContactsPerson.vue?vue&type=template&id=652e5998&"
import script from "./ContactsPerson.vue?vue&type=script&lang=js&"
export * from "./ContactsPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports